// src/index.jsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./i18n";

import { BrowserRouter } from "react-router-dom";
import AppRouter from "./routes/AppRouter";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AppRouter />
        </BrowserRouter>
    </React.StrictMode>
);
